module.exports = __webpack_public_path__ + "img/eshop-1.b3fe38e8.png";